var a=a=>ArrayBuffer.isView(a)&&!(a instanceof DataView);export{a as default};